export default __webpack_public_path__ + "static/media/mypath.a158f924.png";